export var TypeOfFluidContent;
(function (TypeOfFluidContent) {
    TypeOfFluidContent["Freshwater"] = "freshwater";
    TypeOfFluidContent["HFO"] = "HFO";
    TypeOfFluidContent["IFO"] = "IFO";
    TypeOfFluidContent["MDO"] = "MDO";
    TypeOfFluidContent["Lubricants"] = "Lubricants";
    TypeOfFluidContent["Other"] = "Other";
})(TypeOfFluidContent || (TypeOfFluidContent = {}));
//# sourceMappingURL=TypeOfFluidContent.js.map